/* eslint-disable @typescript-eslint/no-explicit-any */
import { types, Instance, flow } from 'mobx-state-tree';
import { AxiosResponse } from 'axios';
import axios from 'server';
import {
  IUserModel,
  UserModel,
  IGroupModel,
  GroupModel,
  DepartmentModel,
  IDepartmentModel,
} from './models/import.model';
import { toFormatDateTime } from 'utils';

const { model, string, array } = types;

export const ImportTableStore = model('ImportTableStore', {
  userLogs: array(UserModel),
  group: array(GroupModel),
  department: array(DepartmentModel),
  filter: string,
})
  .views((self) => ({
    get importView() {
      if (!self.filter) {
        return self.userLogs;
      }
      const regexp = new RegExp(self.filter, 'i');
      return self.userLogs.filter(({ mail, status, name, created_at }) =>
        regexp.test(`${mail}${status}${name}${toFormatDateTime(created_at)}`)
      );
    },
    get groupView() {
      if (!self.filter) {
        return self.group;
      }
      const regexp = new RegExp(self.filter, 'i');
      return self.group.filter(({ cn, status, created_at }) =>
        regexp.test(`${cn}${status}${toFormatDateTime(created_at)}`)
      );
    },
    get departmentView() {
      if (!self.filter) {
        return self.department;
      }
      const regexp = new RegExp(self.filter, 'i');
      return self.department.filter(({ ou, status, created_at }) =>
        regexp.test(`${ou}${status}${toFormatDateTime(created_at)}`)
      );
    },
  }))

  .volatile(() => ({}))
  .actions((self) => ({
    normalizeUserLogs({ data }: AxiosResponse): IUserModel[] {
      self.userLogs.replace(data.data.people);
      return self.userLogs;
    },
    normalizeGroupLogs({ data }: AxiosResponse): IGroupModel[] {
      self.group.replace(data.data.group);
      return self.group;
    },
    normalizeDepartmentLogs({ data }: AxiosResponse): IDepartmentModel[] {
      self.department.replace(data.data.department);
      return self.department;
    },
    setFilter(filter: string) {
      self.filter = filter;
    },
  }))
  .actions((self) => ({
    getImportLdapLogs: flow(function* () {
      const result = yield axios
        .get<IUserModel[]>('invitations/upload-csv-status')
        .then(self.normalizeUserLogs)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    getGroupLogs: flow(function* () {
      const result = yield axios
        .get<IGroupModel[]>('invitations/upload-csv-status')
        .then(self.normalizeGroupLogs)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
    viewUser: flow(function* (id: string) {
      const result = yield axios
        .get<any>(`admin/ldap/user/${id}`)
        .then((res) => res)
        .catch((error) => {
          throw error.response.data;
        });
      return result;
    }),
    getDepartmentLogs: flow(function* () {
      const result = yield axios
        .get<IDepartmentModel[]>('invitations/upload-csv-status')
        .then(self.normalizeDepartmentLogs)
        .catch((error) => {
          throw new Error(error);
        });
      return result;
    }),
  }));

export type IImportTableStore = Instance<typeof ImportTableStore>;
